import React, { useState, useEffect } from 'react';
import { Paper, TextField, FormControl, Input, InputLabel, InputAdornment, IconButton, Button, CircularProgress } from '@material-ui/core';
import logo  from '../assets/img/LogoOficial.png';

const Login = ({login, loading, loginError}) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleMouseDownPassword = event => {
        event.preventDefault();
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleKeyDown = (event) => {
        if(event.keyCode === 13){
            login(username, password);
        }
    }

    return(
        <Paper
            style={{
                height: '100vh', 
                widht: '100vw',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Paper elevation={24}>
                <div 
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '5px', 
                        height: '120px'
                    }}
                >
                    <img src={logo} alt='logo' style={{width: '250px'}}/>
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '5px',
                        fontSize: 10
                    }}
                >
                    v1.0.0
                </div>
                
                <div 
                    style={{
                        paddingLeft: '40px',
                        paddingRight: '40px',
                        paddingBottom: '40px',
                        display: 'flex', 
                        flexDirection: 'column'
                    }}
                >
                    <form noValidate autoComplete="on">
                        <TextField
                            id="username"
                            label="Usuario"
                            value={username}
                            onChange={(event) => setUsername(event.target.value)}
                            margin="normal"
                            fullWidth={true}
                            onKeyDown={handleKeyDown}
                            disabled={loading}
                        />

                        <FormControl fullWidth={true}>
                            <InputLabel htmlFor="adornment-password">Contraseña</InputLabel>
                            <Input
                                id="adornment-password"
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(event) => setPassword(event.target.value)}
                                onKeyDown={handleKeyDown}
                                disabled={loading}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="Toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                        >
                                            {showPassword ? 
                                                <i className="fas fa-eye-slash"></i> 
                                                : 
                                                <i className="fas fa-eye"></i>
                                            }
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </form>
                </div>

                {loginError &&
                    <div 
                        style={{
                            backgroundColor: 'rgba(255, 0, 0, 0.5)', 
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '15px'
                        }}
                    >
                        Usuario o contraseña incorrectos.
                    </div>
                }

                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px'}}>
                    <Button 
                        variant="contained" 
                        color="primary"
                        onClick={() => login(username, password)}
                        disabled={loading}
                    >
                        Entrar 
                        {loading &&
                            <CircularProgress 
                                size={20} 
                                style={{marginLeft: '6px'}}
                            />
                        }
                    </Button>
                </div>
            </Paper>
        </Paper>
    )
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.js